import { differenceInCalendarDays } from 'date-fns';

/**
 * Calendar-day comparisons for the date filter — internal, not part of the public API.
 *
 * Why these exist: date-fns' `isBefore`/`isAfter` compare **instants**, so two `Date`s on the
 * same calendar day but at different times compare as ordered. Every comparison in the filter is
 * about the DAY, never the clock (a calendar cell is a day; a range edge is a day). dayjs spelled
 * that as `.isBefore(other, 'day')`; the date-fns equivalent is a calendar-day difference, which
 * `differenceInCalendarDays` computes directly — no `startOfDay()` round-trip, and DST-safe
 * because it counts calendar days rather than 24-hour spans.
 *
 * `isSameDay` is not restated here — date-fns exports it with exactly these semantics already.
 */

/** `true` when `a` falls on an earlier calendar day than `b` (dayjs' `a.isBefore(b, 'day')`). */
export const isBeforeDay = (a: Date, b: Date) => differenceInCalendarDays(a, b) < 0;

/** `true` when `a` falls on a later calendar day than `b` (dayjs' `a.isAfter(b, 'day')`). */
export const isAfterDay = (a: Date, b: Date) => differenceInCalendarDays(a, b) > 0;
